// Keep the existing YOTY information-page route for its database entry.
export const eventPath = (event) => /\byoty\b|youth of the year/i.test(event.title || '')
  ? '/event/yoty'
  : `/event/${event.id}`;
